import * as localforage from "localforage";
import { phpRequest } from "./phpRequest";

export const updateRoleWithPermissionsAPI = async (
  role_id,
  role_name,
  type
) => {
  const permissions = await localforage.getItem(role_id);
  const extraPermissions = await localforage.getItem(`extra_${role_id}`);

  if (permissions) {
    const checkedPermissionArr = permissions.filter(
      (o) => o.permissionAssignedToRole === "checked"
    );
    const checkedPermissionNameArr = checkedPermissionArr.map((o) => {
      return o.name;
    });

    return phpRequest.put(
      type === 1 ? "/roles/update" : "/roles/nubis/update",
      {
        role_id,
        role_name,
        permissions: [...checkedPermissionNameArr, ...extraPermissions],
      }
    );
  }
  return Promise.reject();
};
